import { Point } from './Point'
import { TweenMax, Linear, TimelineMax } from "gsap";


export class Sprite {
  
  constructor() {
    
    this.points = [];
  }
  
  init() {
    
    let toggleTweens = [];
    
    let swingTweens = [];
    
    let force = this.strength * .00045;
    
    for (let i = 0; i < this.numPoints; i++) {
      
      let point = new Point(this.divisional * (i + 1), this);
      
      point.offset = 1;
      
      this.push(point);
      
      
      swingTweens.push(TweenMax.fromTo(point, 6, { acceleration: -force }, {
        acceleration: force,
        ease: Linear.easeInOut
      }));
      
      // toggleTweens.push(TweenMax.fromTo(point, 2, { offset: 1 }, { offset: 0, ease: Cubic.easeInOut }))
    }
    
    
    this.swingTimeline = new TimelineMax({ tweens: swingTweens.shuffle(), stagger: 1, repeat: -1, yoyo: true })
    
    this.toggleTimeline = new TimelineMax({ tweens: toggleTweens.shuffle(), stagger: .02, paused: true })
  }
  
  render() {
    
    let canvas = this.canvas;
    
    let ctx = this.ctx;
    
    let pointsArray = this.points;
    
    let points = this.numPoints;
    
    let center = this.center;
    
    
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    pointsArray[0].solveWith(pointsArray[points - 1], pointsArray[1]);
    
    
    let p0 = pointsArray[points - 1].position;
    
    let p1 = pointsArray[0].position;
    
    let _p2 = p1;
    
    
    ctx.beginPath();
    
    ctx.moveTo(center.x, center.y);
    
    ctx.moveTo((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);
    
    for (let i = 1; i < points; i++) {
      
      pointsArray[i].solveWith(pointsArray[i - 1], pointsArray[i + 1] || pointsArray[0]);
      
      let p2 = pointsArray[i].position;
      
      let xc = (p1.x + p2.x) / 2;
      
      let yc = (p1.y + p2.y) / 2;
      
      ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);
      
      //ctx.lineTo( p1.x, p1.y );
      
      p1 = p2;
    }
    
    let xc = (p1.x + _p2.x) / 2;
    
    let yc = (p1.y + _p2.y) / 2;
    
    ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);
    
    //ctx.lineTo( p1.x, p1.y );
    
    
    ctx.fillStyle = this.linearGradient;
    
    ctx.fill();
    
    
    this.raf = requestAnimationFrame(this.render.bind(this));
  }
  
  push(item) {
    
    if (item instanceof Point) {
      
      this.points.push(item);
    }
  }
  
  stop() {
    
    cancelAnimationFrame(this.raf);
  }
  
  show() {
    
    this.swingTimeline.play();
    
    this.toggleTimeline.reverse();
  }
  
  hide() {
    
    this.swingTimeline.pause();
    
    this.toggleTimeline.play();
  }
  
  get linearGradient() {
    
    let width = this.canvas.width;
    
    let height = this.canvas.height;
    
    let length = width;
    
    let aspect = height / width;
    
    let angle = (180 + this.gradient.rot) / 180 * Math.PI;
    
    
    let gradient = this.ctx.createLinearGradient(
      width / 2 + Math.cos(angle) * length * 0.5,
      
      height / 2 + Math.sin(angle) * length * 0.5 * aspect,
      
      width / 2 - Math.cos(angle) * length * 0.5,
      
      height / 2 - Math.sin(angle) * length * 0.5 * aspect);
    
    gradient.addColorStop(0, this.gradient.c1);
    
    gradient.addColorStop(1, this.gradient.c2);
    
    
    return gradient;
  }
  
  set gradient(value) {
    
    this._gradient = value;
  }
  
  get gradient() {
    
    return this._gradient || {};
  }
  
  set color(value) {
    
    this._color = value;
  }
  
  get color() {
    
    return this._color || '#000000';
  }
  
  set canvas(value) {
    
    if (value instanceof HTMLElement && value.tagName.toLowerCase() === 'canvas') {
      
      this._canvas = value;
      
      this.ctx = this._canvas.getContext('2d');
    }
  }
  
  get canvas() {
    
    return this._canvas;
  }
  
  set numPoints(value) {
    
    if (value > 2) {
      
      this._points = value;
    }
  }
  
  get numPoints() {
    
    return this._points || 32;
  }
  
  set padding(value) {
    
    if (typeof value == 'object') {
      
      this._padding = value
    }
  }
  
  get padding() {
    
    return this._padding || { x: 0, y: 0 };
  }
  
  get radius() {
    
    return {
      
      x: (this.canvas.width - this.padding.x) / 2,
      
      y: (this.canvas.height - this.padding.y) / 2
    }
  }
  
  set position(value) {
    
    if (typeof value == 'object') {
      
      this._position = value;
    }
  }
  
  get position() {
    
    return this._position || { x: 0.5, y: 0.5 };
  }
  
  get divisional() {
    
    return Math.PI * 2 / this.numPoints;
  }
  
  get center() {
    
    return { x: this.canvas.width * this.position.x, y: this.canvas.height * this.position.y };
  }
  
  set strength(value) {
    
    this._strength = parseInt(value);
  }
  
  get strength() {
    
    return this._strength
  }
  
  set running(value) {
    
    this._running = value === true;
  }
  
  get running() {
    
    return this.running !== false;
  }
}


if (!Array.prototype.shuffle) {
  
  Array.prototype.shuffle = function () {
    
    var currentIndex = this.length, temporaryValue, randomIndex;
    
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      
      // And swap it with the current element.
      temporaryValue = this[currentIndex];
      this[currentIndex] = this[randomIndex];
      this[randomIndex] = temporaryValue;
    }
    
    return this;
  }
}
